const attr = {
  activeClass: "active-class",
  inactiveClass: "inactive-class",
  item: "data-announcement-bar-item",
};

const ACTIVE_ATTR_VALUE = "active";

class AnnouncementBar extends HTMLElement {
  /** @type {Element[]} */
  #$items = [];

  /** @type {string[]} */
  #activeClasses = [];

  /** @type {string[]} */
  #inactiveClasses = [];

  #activeIndex = 0;

  connectedCallback() {
    this.#$items = Array.from(this.querySelectorAll(`[${attr.item}]`));
    if (this.#$items.length === 0) return;

    this.#activeClasses.push(
      ...(this.getAttribute(attr.activeClass) || "")
        .trim()
        .split(" ")
        .filter(Boolean)
    );
    if (!this.#activeClasses.length) return;

    this.#inactiveClasses.push(
      ...(this.getAttribute(attr.inactiveClass) || "")
        .trim()
        .split(" ")
        .filter(Boolean)
    );

    setInterval(this.#changeSlide.bind(this), 4000);
  }

  #changeSlide() {
    const nextActiveIndex =
      this.#activeIndex < this.#$items.length - 1 ? this.#activeIndex + 1 : 0;

    this.#activeIndex = nextActiveIndex;

    this.#$items.forEach(($item, index) => {
      if (index === this.#activeIndex) {
        $item.classList.add(...this.#activeClasses);
        this.#inactiveClasses.length &&
          $item.classList.remove(...this.#inactiveClasses);
      } else {
        $item.classList.remove(...this.#activeClasses);
        this.#inactiveClasses.length &&
          $item.classList.add(...this.#inactiveClasses);
      }
    });
  }
}

customElements.define("announcement-bar", AnnouncementBar);
